import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function taskReducer(state = initialState.tasks, action) {
    switch (action.type) {
        case types.GET_MY_PROJECTS_SUCCESS:
            return action.projects;

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/myProjectsReducer.js
 **/